export const events = {
  goToCompetencies: 'Go to competencies section',
  createCompetency: 'Create competency',
}
